import GuideLayout from '@/pages/shared/GuideLayout';

export default function GuideTaskManagement() {
  return (
    <GuideLayout
      title="プロジェクトタスク管理の方法｜効率的なタスクの整理と割り当て｜”おもいむすび”"
      description="プロジェクトにおけるタスク管理の基本と効率的な方法を解説。タスクの洗い出し、優先順位付け、担当者割り当て、依存関係の設定、進捗追跡のポイント。"
      keywords="プロジェクト管理 タスク管理,プロジェクト タスク 管理方法,タスク 優先順位,タスク 割り当て,タスク 進捗管理"
      canonical="https://omoimusubi.asia/guides/project-task-management/"
      h1="プロジェクトタスク管理の効率的な方法"
      subtitle="プロジェクトを成功に導くためのタスク管理の基本と、AIを活用した効率化の方法を解説します。"
      relatedFeatures={[
        { label: 'AIタスク分解', path: '/features/ai-task-breakdown/' },
        { label: 'AIガントチャート', path: '/features/ai-gantt/' },
        { label: 'チーム機能', path: '/features/team-collaboration/' },
      ]}
      relatedGuides={[
        { label: 'WBSとは', path: '/guides/wbs/' },
        { label: 'プロジェクト進捗管理', path: '/guides/project-progress-management/' },
        { label: 'プロジェクト依存関係', path: '/guides/project-dependency/' },
      ]}
    >
      <section>
        <h2>タスク管理の基本ステップ</h2>
        <ol>
          <li><strong>タスクの洗い出し</strong>：必要な作業をすべてリストアップします。WBSの考え方を活用し、作業の抜け漏れを防ぎます。</li>
          <li><strong>優先順位付け</strong>：重要度と緊急度でタスクを分類します。緊急かつ重要なタスクを最優先で対応します。</li>
          <li><strong>担当者割り当て</strong>：各タスクに適切な担当者をアサインします。メンバーのスキルと現在の負荷を考慮しましょう。</li>
          <li><strong>期限設定</strong>：現実的な期限を設定します。楽観的すぎる見積もりは禁物です。</li>
          <li><strong>依存関係の設定</strong>：タスク間の前後関係を明確にし、クリティカルパスを把握します。</li>
          <li><strong>進捗追跡</strong>：定期的に進捗を確認し、必要に応じて計画を調整します。</li>
        </ol>
      </section>

      <section>
        <h2>タスクの優先順位付けのフレームワーク</h2>
        <p>タスクの優先順位を決める代表的な方法として「アイゼンハワーマトリクス」があります。タスクを「緊急度」と「重要度」の2軸で4象限に分類します。</p>
        <ul>
          <li><strong>緊急かつ重要</strong>：最優先で対応。例：納期が迫っている成果物の作成</li>
          <li><strong>緊急ではないが重要</strong>：計画を立てて着実に進める。例：品質向上のための改善作業</li>
          <li><strong>緊急だが重要ではない</strong>：可能な限り委任する。例：定型的な報告書作成</li>
          <li><strong>緊急でも重要でもない</strong>：後回しまたは削除を検討。例：必要性の低い会議</li>
        </ul>
      </section>

      <section>
        <h2>タスク管理を成功させる3つのポイント</h2>
        <h3>1. タスク名は具体的に</h3>
        <p>「設計書作成」ではなく「〇〇機能の詳細設計書（画面遷移図含む）を作成する」のように、完了条件が明確に判断できる表現にします。</p>
        <h3>2. 1タスクの粒度を適切に</h3>
        <p>1タスクあたり1〜5人日を目安にします。細かすぎると管理コストが増え、粗すぎると進捗把握が難しくなります。</p>
        <h3>3. 定期的な見直し</h3>
        <p>プロジェクトの進行に伴い、新しいタスクが発生したり、優先順位が変わったりします。週次でタスク一覧を見直し、最新の状態を維持しましょう。</p>
      </section>

      <section>
        <h2>AIによるタスク管理の効率化</h2>
        <p>”おもいむすび”のAIタスク分解機能を使えば、企画書や提案書などの資料からAIが自動でタスクを抽出し、担当者候補や期限、依存関係まで提案します。タスクの洗い出しにかかる時間を大幅に削減でき、抜け漏れも防止できます。</p>
        <p>また、AI日報と連動することで、日々の報告からタスクの進捗状況が自動更新されます。「今日は何をすればいいか」が毎朝メンバーごとに自動表示されるため、タスクの優先順位付けや進捗確認の手間が省けます。</p>
      </section>
    </GuideLayout>
  );
}